<template>
  <div>
    <fieldset>
      <div class="row">
        <div class="col-md-4 mb-3 d-flex align-items-center">
          <label class="form-check-label" for="flexSwitchCheckDefault"
            >Show Bravo:</label
          >
     
            <b-form-checkbox
              class="ml-2"
              switch
              value="0"
              :false-value="false"
              :true-value="true"
              v-model="form.showbravo"
            />
       
        </div>

        <div class="col-md-4 mb-3 d-flex align-items-center">
          <label class="form-check-label" for="flexSwitchCheckDefault"
            >Show Bravo Points:</label
          >
          
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              v-model="form.showbravopoints"
            />
      
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label class="form-label" for="bravoheadercolor"
              >Bravo header color:</label
            >
            <b-select
              name="bravoheadercolor"
              class="form-select"
              v-model="form.bravoheadercolor"
            >
              <option value="Orange" style="color: Orange">Orange</option>
              <option value="Brown" style="color: Brown">Brown </option
              ><option value="Yellow" style="color: Yellow">Yellow </option
              ><option value="grey" style="color: grey">grey </option
              ><option value="blue" style="color: blue">blue </option
              ><option value="red" style="color: red">red</option>
            </b-select>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label class="form-label" for="bravoheadercolor"
              >Bravo header font color:</label
            >
            <b-select
              name="bravoheaderfontcolor"
              class="form-select"
              v-model="form.bravoheaderfontcolor"
            >
              <option value="White" style="color: black">White</option>
              <option value="Orange" style="color: Orange">Orange</option>
              <option value="Brown" style="color: Brown">Brown </option
              ><option value="Yellow" style="color: Yellow">Yellow </option
              ><option value="grey" style="color: grey">grey </option
              ><option value="blue" style="color: blue">blue </option
              ><option value="red" style="color: red">red</option>
            </b-select>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label class="form-label" for="bravoheadercolor"
              >Bravo button color:</label
            >
            <b-select
              name="bravobuttoncolor"
              class="form-select"
              v-model="form.bravobuttoncolor"
            >
              <option value="Orange" style="color: Orange">Orange</option>
              <option value="Brown" style="color: Brown">Brown </option
              ><option value="Yellow" style="color: Yellow">Yellow </option
              ><option value="grey" style="color: grey">grey </option
              ><option value="blue" style="color: blue">blue </option
              ><option value="red" style="color: red">red</option>
            </b-select>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label class="form-label" for="bravoheadercolor"
              >Bravo button font color:</label
            >
            <b-select
              name="bravobuttonfontcolor"
              class="form-select"
              v-model="form.bravobuttonfontcolor"
            >
              <option value="White" style="color: black">White</option>
              <option value="Orange" style="color: Orange">Orange</option>
              <option value="Brown" style="color: Brown">Brown </option
              ><option value="Yellow" style="color: Yellow">Yellow </option
              ><option value="grey" style="color: grey">grey </option
              ><option value="blue" style="color: blue">blue </option
              ><option value="red" style="color: red">red</option>
            </b-select>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script>
export default {
  name: "BravoModule",
  data() {
    return {};
  },
  computed: {
    form() {
      return this.$store.state.manageClients.form;
    },
  },
};
</script>
<style></style>
